module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADkAAAAvBAMAAACruX8wAAAAG1BMVEW8vLwAAAAXFxdGRkZ1dXWkpKSNjY0vLy9eXl7Lz5qsAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAA1ElEQVQ4je2QsQ6CMBCGf5Giow2gzBrjionR1RofAE10piY6gw6uQnxw79pCnHwB+QYuX//22gPo+G88KUdKSnkNgSoHSrDlLu2t9tvz7VZRJGiDL2HMcbDbHvCKwRw4ltaaNONvEMOP1BbYKGsOXVI/9AvgvuB15cxyeVcpdaBjhzG9MeWUrWFIfWruMubKaf01k6DVhOp9ChGZNGmzE6c+Hfcj/RrSqKExx4bF46uLfixo1Kux5s3rXQpNQy8zMSGnzjpv06CcAU+qif2TylhHxy8+eQUieYinrOgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon02.png
// module id = RJrZ
// module chunks = 0